import React, { memo } from 'react';
import { INVENTORY_TAB_PATHS } from '@root/constants/inventoryTabs';
import { Box, Grid, Skeleton } from '@mui/material';
import NoData from '@root/components/common/NoData';
import ContentBox from '@root/components/v2/content/ContentBox';
import PieCharts from '../charts/PieChart';
// import TopOpenTooltip from '@root/components/v2/ui-elements/Tooltip/TopOpenTooltip';
import '../style.scss';
// import { RISK_COLORS_PASTEL, RISK_COLORS } from '@root/utilities/colors';
import { useCallback } from 'react';
import useRedirectWithParams from '@root/hoc/redirection';
import { SEVERITY_COLORS, UI_COLORS } from '@root/utilities/pastelColors';
import { useTheme } from '@root/context/ThemeContext';

const colors = {
  Critical: SEVERITY_COLORS.critical,
  High: SEVERITY_COLORS.high,
  Medium: SEVERITY_COLORS.medium,
  Low: SEVERITY_COLORS.low,
};

const HealthScoreBreakdown = props => {
  const {
    health_score_breakdown,
    isFetchingHealthScoreBreakdown,
    title = 'Health Score Breakdown',
    // isKubernetes = false,
    height = '406px',
    infoMsg,
    count_msg = 'Risk',
    // colors = RISK_COLORS_PASTEL,
    legendLabelKey = 'Severity',
    legendLabelValue = 'Resources',
    redirection = false,
  } = props;
  const { isDarkMode } = useTheme();

  const redirectWithParams = useRedirectWithParams();
  const handleRedirect = useCallback(
    item => {
      const defaultBreadCrumbs = [
        { title: 'Inventory' },
        { title: 'Resource', path: INVENTORY_TAB_PATHS.overview },
        { title: item?.toUpperCase() },
      ];
      if (title === 'Health Score Breakdown') {
        redirectWithParams({
          url: `${INVENTORY_TAB_PATHS.resources}&severity=${item.toLowerCase()}`,
          breadcrumbs: defaultBreadCrumbs,
        });
      }
    },
    [redirectWithParams, title],
  );
  return (
    <>
      <Grid item>
        <ContentBox
          title={<>{title}</>}
          infoMsg={infoMsg ?? 'Health score breakdown based on resource severity'}
          titleSize="medium"
          padding="0px"
          height={height}
          titleContainerStyle={{
            // border: "0px",
            fontSize: '16px !important',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
            // borderBottom: '1px solid #CBD5E0',
            padding: '11.04px 15px',
            margin: '0px',
          }}
          containerClassName={'border-box-no-pad'}
          paddingMode="content">
          {isFetchingHealthScoreBreakdown ? (
            <Box display="flex" flexDirection="column" alignItems="center" padding="15px" paddingTop="35px">
              <Box width="100%" display="flex" justifyContent="center" marginBottom={'20px'}>
                <Skeleton variant="circular" width="160px" height="160px" />
              </Box>
              <Box flexGrow={0.4} height="10px" width="100%" />

              <Box width="100%" display="flex" flexDirection="row" justifyContent="space-between" marginBottom="5px">
                <Skeleton width="100px" />
                <Skeleton width="100px" />
              </Box>
              <Grid sx={{ width: '100%' }}>
                {Array.from(new Array(4)).map((i, index) => (
                  <Box key={i} width="100%" display="flex" flexDirection="column" gap={'10px'}>
                    <Box
                      display="flex"
                      flexDirection="row"
                      justifyContent="space-between"
                      marginTop={index === 0 ? '0px' : '8px'}>
                      <Skeleton width="80px" />

                      <Skeleton width="80px" />
                    </Box>
                  </Box>
                ))}
              </Grid>
            </Box>
          ) : health_score_breakdown?.data?.length === 0 ? (
            <NoData height={'350px'} />
          ) : (
            <div style={{ padding: '15px' }}>
              {/* <Grid>
                  <CircleWithText score={threats?.data?.total_threats} />
                </Grid> */}
              <Grid className="inventory_new">
                <Grid sx={{ display: 'flex', justifyContent: 'center', pt: '5px' }}>
                  <PieCharts
                    chartData={health_score_breakdown?.data?.risk_breakup}
                    count_msg={count_msg}
                    count_value={health_score_breakdown?.data?.total_risk}
                    colors={colors}
                  />
                </Grid>
                <Grid sx={{ display: 'flex', justifyContent: 'space-between', py: '10px' }}>
                  <p className="card_sub_heading legend-heading  m-0" style={{}}>
                    {' '}
                    {legendLabelKey}
                  </p>
                  <p className="card_sub_heading legend-heading  m-0"> {legendLabelValue} </p>
                </Grid>
                <Grid sx={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
                  {health_score_breakdown?.data?.risk_breakup.map(item => {
                    return (
                      <>
                        <Grid sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Grid sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <p
                              className="m-0"
                              style={{
                                width: '10px',
                                height: '10px',
                                background: colors[item.name] ?? colors[item.name.toLowerCase()],

                                borderRadius: '50%',
                              }}></p>
                            {/* <img src={aws_icon} alt="" style={{ width: '22px', height: '14px' }} /> */}
                            <p
                              style={{ color: isDarkMode ? UI_COLORS.text.secondary : UI_COLORS.text.primary }}
                              className="title legend-text  m-0">
                              {item.name?.charAt(0)?.toUpperCase() + item.name?.slice(1)?.toLowerCase()}{' '}
                            </p>
                            {/* <p className="title legend-text  m-0">{item.name} </p> */}
                          </Grid>

                          <p
                            style={{
                              color: isDarkMode
                                ? UI_COLORS.text.secondary
                                : redirection
                                ? '#0000FF'
                                : UI_COLORS.text.primary,
                              cursor: redirection && item.value !== 0 ? 'pointer' : 'default',
                              lineHeight: 'normal',
                            }}
                            onClick={redirection && item.value !== 0 ? () => handleRedirect(item.name) : () => {}}
                            className="title legend-value m-0 ">
                            {' '}
                            {item.value}
                          </p>
                        </Grid>
                      </>
                    );
                  })}
                </Grid>
              </Grid>
            </div>
          )}
        </ContentBox>
      </Grid>
    </>
  );
};

export default memo(HealthScoreBreakdown);
